// extracted by mini-css-extract-plugin
export var articleNav = "singleBlog-module--articleNav--3Wbaw";
export var blogContent = "singleBlog-module--blogContent--1AHay";